/**
 * Application Configuration
 *
 * This file provides configuration values based on the environment.
 * It handles different settings for development and production.
 */

// API URL - defaults to api.gruper.net for production, can be overridden
const API_URL = process.env.REACT_APP_API_URL || 'https://api.gruper.net';

// Google Analytics Measurement ID
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

// Export configuration
const config = {
  apiUrl: API_URL,
  gaMeasurementId: GA_MEASUREMENT_ID,

  // Derived URLs for specific endpoints
  endpoints: {
    health: `${API_URL}/health`,
    version: `${API_URL}/version`,
    adminEnv: `${API_URL}/admin/api/env`,
    adminAuthStatus: `${API_URL}/admin/auth-status`,
    adminLogin: `${API_URL}/admin/login`,
    adminLogout: `${API_URL}/admin/logout`,
    adminChannels: `${API_URL}/admin/api/channels`,
    webhook: `${API_URL}/webhook/whatsapp`,
    onboardingStatus: `${API_URL}/admin/api/onboarding/status`,
    onboardingVerify: `${API_URL}/admin/api/onboarding/verify`,
    onboardingVerifyCode: `${API_URL}/admin/api/onboarding/verify-code`,
    onboardingComplete: `${API_URL}/admin/api/onboarding/complete`,
    onboardingChannelVerify: (channelId) => `${API_URL}/admin/api/onboarding/channel/${channelId}/verify`,
    channelStatus: (channelId) => `${API_URL}/admin/api/channel/${channelId}/status`,
    onboardingRequestStatus: (requestId) => `${API_URL}/admin/api/onboarding/request/${requestId}`
  }
};

export default config;
